import ENV from "../config/environment"
import * as filestackLibrary from "filestack-js"
export function initialize(appInstance) {
  window.filestack = filestackLibrary
  let filestack = appInstance.lookup("service:filestack")
  // We do this to make sure the picker library loads. Otherwise,
  // there's a big delay when we initialize the dropzone.
  if (window && window.document && ENV.environment !== "test") {
    filestack.client.picker({
      container: "dummy-dropzone",
      dropPane: {},
    })
  }
}

export default {
  name: "filestack",
  initialize: initialize,
}
